<template>
  <button
    class="flex cursor-pointer px-4 py-1.5"
    :class="{
      'border-b-2 border-primary-600 text-type-primary': activeIndex === index,
      'border-b border-grey-35 text-type-tertiary': activeIndex !== index,
    }"
    @click="activeIndex = index"
  >
    <div class="text-nowrap text-sm font-semibold leading-tight tracking-wide">
      {{ label }}
    </div>
  </button>
</template>

<script setup lang="ts">
const activeIndex = defineModel<number>();

defineEmits(['update:modelValue']);

defineProps<{
  index: number;
  label: string;
}>();
</script>
